// @ts-expect-error TS(7006) FIXME: Parameter 'text' implicitly has an 'any' type.
export const shortenText = (text, MAX_SIZE) => {
  if (!text) return null

  let result = text

  if (result.length > MAX_SIZE) {
    result = result.slice(0, MAX_SIZE).concat('...')
  }

  return result
}
